import { getFileExtension, getFileTitle } from './File';

// enum that refers to the locations of different sizes
// of images for student ids, generated by cloud function
export enum StudentIdPresetSize {
  RAW = 'raw', // the unchanged image
  ID_FULL = 'id_full', // full size for full page id
  THUMB = 'thumb', // thumb for list page.
  AVATAR = 'avatar', // 95x95 size of the id
  UPLOAD = 'upload'// the initial upload, not processed
}

export const TempImageDirectory = StudentIdPresetSize.UPLOAD; 

/**
 * Gets the generated file path under firebase storage for the file, using
 * the given preset. Files are stored in storage at path
 * <mingaHash>/<preset>/<personHash>.jpg
 */
export function getFilePath(filename: string, preset: StudentIdPresetSize = StudentIdPresetSize.RAW, mingaHash: string, jobId?: string): string {
  // const minga = await this.mingaService.getMingaAsPromise();
  // const mingaHash = minga.hash;
  let folder = '';
  if (preset == StudentIdPresetSize.AVATAR) {
    folder = 'studentid/';
    const ext = getFileExtension(filename, true);
    const name = getFileTitle(filename);
    filename = name + '.' + ext;
  }

  let fileDirectory: string;
  if (preset == TempImageDirectory) {
    fileDirectory = folder + mingaHash + '/' + preset + '/' + jobId + '/' + filename;
  } else {
    fileDirectory = folder + mingaHash + '/' + preset + '/' + filename;
  }
  return fileDirectory;
}

